/*
 * Early-Bird-Geschenk: legt ab 85 EUR Warenwert automatisch ein 10-ml-Oel gratis in den Warenkorb.
 * Gehoert zum Shopify-Rabatt "Early-Bird Geschenk: 10 ml gratis ab 85 EUR (03.-08.11.2026)".
 * Nur im Zeitfenster aktiv. Bleibt das Geschenk nicht gratis (final_line_price > 0), wird es wieder entfernt.
 * Test: ?eb_test=1 ignoriert das Zeitfenster, zusaetzlich ?eb_nocheck=1 ueberspringt die Gratis-Pruefung.
 */
(function () {
  var START = Date.parse('2026-11-03T07:00:00Z');
  var END = Date.parse('2026-11-08T22:59:59Z');
  var THRESHOLD = 8500; // Cent, Warenwert ohne Geschenk
  var VARIANT = { latsche: 62248972091779, zirbe: 62248996798851 };
  var IT = location.pathname.indexOf('/it') === 0 && (location.pathname.length === 3 || location.pathname.charAt(3) === '/');

  var store = {
    get: function (k) { try { return sessionStorage.getItem(k) || ''; } catch (e) { return ''; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  if (/[?&]eb_test=1/.test(location.search)) store.set('eb_test', '1');
  if (/[?&]eb_nocheck=1/.test(location.search)) store.set('eb_nocheck', '1');

  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var internal = 0, busy = false, pending = false, timer = null;

  function isGift(item) { return item.properties && item.properties._eb_gift === '1'; }
  function getCart() { return nativeFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return nativeFetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function refreshUI() {
    var ci = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
    var p = (ci && typeof ci.onCartUpdate === 'function') ? ci.onCartUpdate() : Promise.resolve();
    return Promise.resolve(p).then(function () {
      return nativeFetch('/?section_id=cart-icon-bubble').then(function (r) { return r.text(); }).then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var src = doc.querySelector('#cart-icon-bubble');
        var dst = document.querySelector('#cart-icon-bubble');
        if (src && dst) dst.innerHTML = src.innerHTML;
      }).catch(function () {});
    }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }).catch(function () {});
  }

  function removeGift(line) { return post('/cart/change.js', { line: line, quantity: 0 }); }

  function chooseGift(others) {
    var z = others.some(function (i) { return /zirb/i.test(i.handle || ''); });
    var l = others.some(function (i) { return /latsch/i.test(i.handle || ''); });
    // Geschenk ist das Oel, das noch nicht im Warenkorb liegt; sonst Latsche
    if (z && !l) return VARIANT.latsche;
    if (l && !z) return VARIANT.zirbe;
    return VARIANT.latsche;
  }

  function sync() {
    if (busy) { pending = true; return Promise.resolve(); }
    busy = true; internal++;
    var now = Date.now(), test = store.get('eb_test') === '1', nocheck = store.get('eb_nocheck') === '1';
    var active = test || (now >= START && now <= END);
    return getCart().then(function (cart) {
      var gifts = [], others = [], giftLine = 0;
      cart.items.forEach(function (it, idx) { if (isGift(it)) { gifts.push(it); giftLine = idx + 1; } else { others.push(it); } });

      if (!active) {
        // nach Ablauf uebrig gebliebene Geschenkzeilen entfernen, vor dem Start nichts tun
        if (now > END && gifts.length) return removeGift(giftLine).then(refreshUI);
        return;
      }
      var qualifying = others.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      var want = qualifying >= THRESHOLD;

      if (!want) {
        store.set('eb_optout', ''); store.set('eb_added', ''); store.set('eb_fail', '');
        if (gifts.length) return removeGift(giftLine).then(refreshUI);
        return;
      }
      if (gifts.length) {
        if (gifts.length > 1 || gifts[0].quantity > 1) {
          return post('/cart/change.js', { line: giftLine, quantity: 1 }).then(refreshUI);
        }
        return;
      }
      // Geschenk fehlt: vom Kunden entfernt oder noch nie hinzugefuegt
      if (store.get('eb_added') === '1') { store.set('eb_optout', '1'); store.set('eb_added', ''); }
      if (store.get('eb_optout') === '1') return;
      if (store.get('eb_fail') === String(qualifying)) return;

      var props = { '_eb_gift': '1' };
      props[IT ? 'Regalo' : 'Geschenk'] = IT ? 'Early Bird, da 85 EUR' : 'Early-Bird, ab 85 EUR';
      return post('/cart/add.js', { items: [{ id: chooseGift(others), quantity: 1, properties: props }] }).then(function (r) {
        if (!r.ok) return;
        store.set('eb_added', '1');
        return getCart().then(function (c2) {
          var idx = -1;
          c2.items.forEach(function (it, i) { if (isGift(it)) idx = i; });
          if (idx > -1 && !nocheck && c2.items[idx].final_line_price > 0) {
            // Rabatt greift nicht: Geschenk wieder raus, fuer diesen Warenwert nicht erneut versuchen
            store.set('eb_added', ''); store.set('eb_fail', String(qualifying));
            return removeGift(idx + 1);
          }
        }).then(refreshUI);
      });
    }).catch(function () {}).then(function () {
      internal--; busy = false;
      if (pending) { pending = false; schedule(); }
    });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 600); }

  // Warenkorb-Aenderungen mitbekommen (fetch + XHR), eigene Aufrufe ausnehmen
  var CART_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if (window.fetch) {
    var wrapped = window.fetch;
    window.fetch = function (input) {
      var p = wrapped.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (!internal && CART_URL.test(url)) p.then(schedule, function () {});
      } catch (e) {}
      return p;
    };
  }
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__ebUrl = u; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__ebUrl && CART_URL.test(String(this.__ebUrl))) this.addEventListener('loadend', function () { if (!internal) schedule(); });
    return xs.apply(this, arguments);
  };
  document.addEventListener('cart:updated', function () { if (!internal) schedule(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
